// import dayjs from 'dayjs';
// import relativeTime from 'dayjs/plugin/relativeTime';
// import utc from 'dayjs/plugin/utc';
import moment from 'moment';
// dayjs.extend(relativeTime);
// dayjs.extend(utc);

/**
 * Format bytes as human-readable text.
 * 
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use 
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 * 
 * @return Formatted string.
 */
export function HumanFileSize(bytes, si = false, dp = 1) {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + ' B';
  }

  const units = si
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


  return bytes.toFixed(dp) + ' ' + units[u];
}

// export function Truncate(str, n) {
//   return (str.length > n) ? str.substr(0, n - 1) + '...' : str;
// };

export function dateRelative(value) {
  return value ? moment(value).fromNow() : '';
  if (value) {
  } else {
    return '';
  }
}

// export function dateLong(value) {
//   if (value) {
//     const date = new Date(value);
//     return date.toLocaleString("en-US");
//   } else {
//     return '';
//   }
// }

export function parseDate(d, inputs = ['MM/DD/YYYY', 'M/DD/YYYY', 'YYYY/MM/DD', 'YYYY-M-DD', moment.ISO_8601], output = 'M/DD/YYYY') {
  try {
    const date = moment(d || null, inputs, true)
    if (!date.isValid()) return
    return date.format(output)
  } catch (error) {
    return
  }
}

export function dateShort(value, outputFormat = "MM/DD/YYYY") {
  return value ? parseDate(value, undefined, outputFormat) : ''
}

export function currencyUSD(value) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  });

  return formatter.format(value);
}

export function numberFormatted(value) {
  const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0 });

  return formatter.format(value);
}